import * as SearchActions from '../actions/mobile-search.actions';
import {createReducer, on} from '@ngrx/store';

export interface State {
    isDecorTypeOpen: boolean;
    isProductTypeOpen: boolean;
    isOccasionTypeOpen: boolean;
    isSortOpen: boolean;
    isPurposeTypeOpen: boolean;
    isProductCategoryTypeOpen: boolean;
    isColorTypeOpen: boolean;
}

const initialState: State = {
    isDecorTypeOpen: false,
    isOccasionTypeOpen: false,
    isProductTypeOpen: false,
    isPurposeTypeOpen: false,
    isProductCategoryTypeOpen: false,
    isColorTypeOpen: false,
    isSortOpen: false
};

export const reducer = createReducer(
    initialState,
    on(SearchActions.closeSubmenu, () => ({...initialState})),
    on(SearchActions.openSubmenu, (state, action) => {
        const keyToUpdate = Object.keys(state).find(key => key.toLowerCase().includes(action.menuType.toLowerCase()));
        console.log("key to update", keyToUpdate)
        const resetState = {...initialState, [keyToUpdate]: true};
        return resetState;
    })
);

export const getIsDecorTypeOpen = (state: State) => state.isDecorTypeOpen;
export const getIsProductTypeOpen = (state: State) => state.isProductTypeOpen;
export const getIsOccasionTypeOpen = (state: State) => state.isOccasionTypeOpen;
export const getIsPurposeTypeOpenOpen = (state: State) => state.isPurposeTypeOpen;
export const getIsProductCategoryTypeOpen = (state: State) => state.isProductCategoryTypeOpen;
export const getIsColorTypeOpen = (state: State) => state.isColorTypeOpen;
export const getIsSortOpen = (state: State) => state.isSortOpen;
